import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ROLE_END_USER, ROLE_INTERMEDIATE, ROLE_WHOLESALER } from '../../../core/interfaces/home-market-bonus.interface';

@Pipe({ name: 'translateRole' })
export class TranslateRolePipe implements PipeTransform {

  private translateService = inject(TranslateService);

  transform(role) {
    return role
      .replace(ROLE_WHOLESALER, this.translateService.instant('HOME_MARKET_BONUS.ROLES.WHOLESALER'))
      .replace(ROLE_END_USER, this.translateService.instant('HOME_MARKET_BONUS.ROLES.END_USER'))
      .replace(ROLE_INTERMEDIATE, this.translateService.instant('HOME_MARKET_BONUS.ROLES.INTERMEDIATE'));
  }
}
